import { render, staticRenderFns } from "./AppDashboard.vue?vue&type=template&id=9451d35e&scoped=true&"
import script from "./AppDashboard.vue?vue&type=script&lang=js&"
export * from "./AppDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AppDashboard.vue?vue&type=style&index=0&id=9451d35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9451d35e",
  null
  
)

export default component.exports